import {dict} from '@/assets/js/dict'
export default {
    data() {
        return {
            family_name_spell_suggestion: [],
            given_name_spell_suggestion: [],
            name_spell_suggestion: [],
            listAll:[],
            frontName:[],
            backName:[],
            frontNameList:[],
            backNamelist:[],
        }
    },
    methods:{
        familyNameSearch(queryString, cb) {
            if (this.listAll.length ===0 || this.canChangeName){
                this.getAllList()
            }
            if (this.family_name_spell_suggestion.length ===0 || this.canChangeName){
                if (this.frontName){
                    this.getFrontName()
                }else{
                    this.getFamilyNameSuggestions()
                }

            }
            const res = this.filterList(queryString,this.family_name_spell_suggestion)
            cb(res)
        },
        givenNameSearch(queryString, cb) {
            if (this.listAll.length ===0 || this.canChangeName){
                this.getAllList()
            }
            if (this.given_name_spell_suggestion.length===0 || this.canChangeName){
                if (this.backName){
                    this.getBackName()
                }else{
                    this.getGivenNameSuggestions()
                }

            }
            const res = this.filterList(queryString,this.given_name_spell_suggestion)
            cb(res)
        },
        name_spell_search(queryString,cb){
            if (this.listAll.length ===0 || this.canChangeName){
                this.getAllList()
            }
            if (this.name_spell_suggestion.length ===0  || this.canChangeName){
                this.getNameSuggestions()
            }
            const res = this.filterList(queryString,this.name_spell_suggestion)
            cb(res)
        },
        getFamilyNameSuggestions() {
            this.family_name_spell_suggestion = []
            if (this.vitaForm.name !== '') {
                const length = this.listAll.length
                this.family_name_spell_suggestion.push.apply(this.family_name_spell_suggestion, this.listAll[0])
                // 第一个字
                if (length >= 3) {
                    let res = this.mergeArray(this.listAll[0], this.listAll[1])
                    this.family_name_spell_suggestion.push.apply(this.family_name_spell_suggestion, res)
                    for (let i = 2; i < length - 1; i++) {
                        res = this.mergeArray(res, this.listAll[i])
                        this.family_name_spell_suggestion.push.apply(this.family_name_spell_suggestion, res)
                    }
                }
            }
        },
        getFrontName(){
            this.family_name_spell_suggestion = [] ;
            this.frontNameList = this.listAll.slice(0,this.frontName.length)
            let res = this.frontNameList[0]
            if (res.length >= 1) {
                for (let i = 1; i < this.frontNameList.length; i++) {
                    res = this.mergeArray(res, this.frontNameList[i])
                }
                this.family_name_spell_suggestion = res.slice()
            }
        },
        getBackName(){
            this.given_name_spell_suggestion = []
            this.backNameList = this.listAll.slice(this.frontName.length)
            let res = this.backNameList[0]
            if (res.length >= 1) {
                for (let i = 1; i < this.backNameList.length; i++) {
                    res = this.mergeArray(res, this.backNameList[i])
                }
                this.given_name_spell_suggestion = res.slice()
            }
        },
        getGivenNameSuggestions() {
            this.given_name_spell_suggestion = []
            if (this.vitaForm.name !== '') {
                const length = this.listAll.length
                this.given_name_spell_suggestion.push.apply(this.given_name_spell_suggestion, this.listAll[length-1])
                if (length >= 3) {
                    let res = this.mergeArray(this.listAll[length-2], this.listAll[length-1])
                    this.given_name_spell_suggestion.push.apply(this.given_name_spell_suggestion, res)
                    for (let i = length - 3; i > 0; i--) {
                        res = this.mergeArray(this.listAll[i], res)
                        this.family_name_spell_suggestion.push.apply(this.given_name_spell_suggestion, res)
                    }
                }
            }
        },
        getNameSuggestions(){
            this.name_spell_suggestion = []
            if (this.vitaForm.name !== '') {
                const length = this.listAll.length
                let res = this.listAll[0]
                if (length >= 1) {
                    for (let i = 1; i < length; i++) {
                        res = this.mergeArray(res, this.listAll[i])
                    }
                }
                this.name_spell_suggestion.push.apply(this.name_spell_suggestion, res)
            }
        },
        mergeArray(a, b) {
            let res = []
            for (let i = 0; i < a.length; i++) {
                for (let j = 0; j < b.length; j++) {
                    res.push(a[i] + b[j])
                }
            }
            return res
        },
        getResult(query, spells) {
            console.log(query,'--')
            let result = []
            spells.forEach(item => {
                if (item.indexOf(query.toLowerCase()) > -1) {
                    result.push(item)
                }
            })
            return result.length > 0 ? result : spells
        },
        getAllList(){
            let name;
            if (this.vitaForm.name.indexOf('·') > -1) {
                let name_new = this.vitaForm.name.replace(' ','').split('·').reverse()
                this.frontName = name_new[0]
                this.backName = name_new[1]
                name =name_new.join('')
            }else{
                this.frontName=''
                this.backName=''
                name = this.vitaForm.name.replace(' ','')
            }
            // let name=this.vitaForm.name.replace('·','')
            let list =[];
            for (let i=0;i<name.length;i++){
                let everyList=[];
                for (let key in dict){
                    if (dict[key].indexOf(name[i]) > -1){
                        everyList.push(key)
                    }
                }
                list.push(everyList)
            }
            this.listAll=list;
        },
        filterList(str,arr){
            let allList=[],list=[];
            arr.forEach(item =>{
                allList.push({
                    value:item.toUpperCase()
                })
                if (str && item.indexOf(str.toLowerCase()) > -1){
                    list.push({
                        value:item.toUpperCase()
                    })
                }
            })
            return list.length > 0 ? list : allList
        }
    }
}
